import { Button } from "@/components/ui/button";
import { Trash2, PenLine } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";


export function DeleteDialog({
  isOpen,
  onClose,
  onConfirm,
  personName,
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader className={`flex justify-center items-center gap-2`}>
          <Button className="bg-cblack7" size="icon" variant="">
            <Trash2 className="text-cred" />
          </Button>
          <DialogTitle>Are yor Sure ?</DialogTitle>
          <DialogDescription>
            You want to delete all the marked item, this can’t be undone once
            you delete.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <div className={`flex w-full justify-center gap-5 items-center`}>
            <Button className="bg-cblack7 text-cwhite2" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              className="bg-cred"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              Yes, Delete
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}